import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';


// const requestOptions = { 
//   headers: new HttpHeaders({ 
//       "Access-Control-Allow-Origin": "*",
//       "accept": "application/json",
//       'Cache-Control': "no-cache",
//       "X-XSS-Protection": "1; mode=block",
//       "Content-Security-Policy": "default-src 'self'",
//       "Content-Type": "application/json" }) 
//   };

const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class FolderManagementService {

  constructor(private _http: HttpClient) {
  }

  getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };

  getFolderTemplate(engagementId): Promise<any> {
    return this._http.get<any>(environment.APIEndpoint + 'api/FolderMgmt/GetFolderTemplate?engagementId=' + engagementId)
      .toPromise()
      .then(res => JSON.parse(res))
      .catch(this._errorHandler);
  }

  saveFolderTemplate(arrFolderTree, engagementId): any {
    var body = JSON.stringify(arrFolderTree, this.getCircularReplacer());
    body = body.replace(',null', '');
    return this._http.post(environment.APIEndpoint + 'api/FolderMgmt/SaveFolderTemplate?engagementId=' + engagementId, body, httpOptions)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }
  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }
}
